import '../scss/foundation.scss';
import '../scss/main.scss';

import lax from 'lax.js';
import slick from 'slick-carousel';

// Either import everything
//import 'foundation-sites;

// Or import individual modules
/**/
import 'foundation-sites/dist/js/plugins/foundation.core';
import 'foundation-sites/dist/js/plugins/foundation.dropdownMenu.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.keyboard.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.box.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.nest.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.mediaQuery';
import 'foundation-sites/dist/js/plugins/foundation.util.imageLoader';//
import 'foundation-sites/dist/js/plugins/foundation.util.motion';
import 'foundation-sites/dist/js/plugins/foundation.util.triggers';
import 'foundation-sites/dist/js/plugins/foundation.util.touch';
import 'foundation-sites/dist/js/plugins/foundation.equalizer';
import 'foundation-sites/dist/js/plugins/foundation.reveal';

import Accordions from './modules/Accordions';
import './modules/articleSlider';
import './modules/caseStudySlider';
import './modules/videoSlider';
import './modules/teamSlider';

// ie checker
function detectIEEdge() {
    var ua = window.navigator.userAgent;

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
		// IE 10 or older => return version number
		//alert('ie 10');
		document.body.classList.add("ie-fix");
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
		// IE 11 => return version number
		document.body.classList.add("ie-fix");
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

	var safari = ua.indexOf('Safari');
    if (safari > 0) {
		if(ua.indexOf('Chrome') > -1){

		} else {
			console.log('safari');
			document.body.classList.add("safari-fix");
		}
    }

    // other browser
    return false;
}

//console.log('Entry Loaded');
document.addEventListener("DOMContentLoaded", function () {
	$(document).foundation();

	detectIEEdge();

	// mobile hamburger menu
	$('.hamburger').on('click', function (e) {
		$('.hamburger').toggleClass('is-active');
		$('.nav-menu-container').toggleClass('is-active');
		$('.sec-menu').removeClass('menu-active');
		e.preventDefault();
	});

	// subnav
	$('.btn-job-search').on('click', function (e) {
		$('.subnav-link').toggleClass('is-open');
		$('.subnav').toggleClass('is-open');
		e.preventDefault();
	});

	//secondary menu
	$('.secondary-menu-btn').on('click', function (e) {
		e.preventDefault();
		$('.sec-menu').toggleClass('menu-active');
		$(this).toggleClass('is-active');
		//$('.sec-menu-link').first().addClass('sec-menu-active');
	});

	// $('.sec-menu-find').on("mouseover", function () {
	// 	$('.sec-menu-link').removeClass('sec-menu-active');
	// 	$(this).addClass('sec-menu-active');
	// 	$('.sec-menu-sub-find').addClass('is-active');
	// 	$('.sec-menu-sub-excite').removeClass('is-active');
	// 	$('.sec-menu-sub-secure').removeClass('is-active');
	// });
	// $('.sec-menu-excite').on("mouseover", function () {
	// 	$('.sec-menu-link').removeClass('sec-menu-active');
	// 	$(this).addClass('sec-menu-active');
	// 	$('.sec-menu-sub-find').removeClass('is-active');
	// 	$('.sec-menu-sub-excite').addClass('is-active');
	// 	$('.sec-menu-sub-secure').removeClass('is-active');
	// });
	// $('.sec-menu-secure').on("mouseover", function () {
	// 	$('.sec-menu-link').removeClass('sec-menu-active');
	// 	$(this).addClass('sec-menu-active');
	// 	$('.sec-menu-sub-find').removeClass('is-active');
	// 	$('.sec-menu-sub-excite').removeClass('is-active');
	// 	$('.sec-menu-sub-secure').addClass('is-active');
	// });

	$('#maincontent').on('click', function (e) {
		//e.preventDefault();
		$('.header').removeClass('search-is-open');
		$('.sec-menu').removeClass('menu-active');
		$('.secondary-menu-btn').removeClass('is-active');
		$('.search-container').removeClass('is-open');
		$('.subnav-link').removeClass('is-open');
		$('.subnav').removeClass('is-open');
		$('.nav-menu-container').removeClass('is-active');
		$('.hamburger').removeClass('is-active');		
	});

	$('.btn-site-search').on('click', function (e) {
		$('.header').toggleClass('search-is-open');
		$('.search-container').toggleClass('is-open');
		e.preventDefault();
	});

	// back to top button
	var btn = $('#topbutton');

	$(window).scroll(function () {
		if ($(window).scrollTop() > 300) {
			btn.addClass('show');
		} else {
			btn.removeClass('show');
		}
	});

	btn.on('click', function (e) {
		e.preventDefault();
		$('html, body').animate({ scrollTop: 0 }, '300');
	});

	// video list modal open
	$('.video-list-modal-link').on('click', function() {
		$('#video-list-modal').foundation('open');		     
		$('.embed-player').attr("src", $(this).attr('data-video-link'));
		$('.embed-player').attr("title", $(this).attr('data-video-title'));
	});

	// reveal video close and stop
	$('.reveal-overlay').on('click', function (e) {
		$('.reveal-video iframe').attr('src', '');
	});
	$('.reveal-video .close-button').on('click', function (e) {
		$('.reveal-video iframe').attr('src', '');
	});
	$(document).on('keyup',function(evt) {
		if (evt.keyCode == 27) {
			$('.reveal-video iframe').attr('src', '');
		}
	});

	// home tabs
	// $('.home-intro-tab').click(function () {
	// 	var t = $(this).data('tab');
	// 	if ($('.home-intro-bg').hasClass(t)) {
	// 		$('.home-intro-bg').removeClass('active');
	// 		$('.home-intro-bg.' + t).addClass('active');
	// 	}

	// 	$('.home-intro-tab').removeClass('active');
	// 	$(this).addClass('active');

	// 	if ($('.home-intro-tab-content').hasClass(t)) {
	// 		$('.home-intro-tab-content').removeClass('active');
	// 		$('.home-intro-tab-content.' + t).addClass('active');
	// 	}
	// });

	// service carousel
	$('.service-slider').slick({
		infinite: true,
		dots: true,
		arrows: false,
		autoplay: false,
		autoplaySpeed: 3000,
		fade: true,
		fadeSpeed: 1000
	});
	// service dots
	$('.service-dots .slick-dot').click(function () {
		var goToThisIndex = $(this).data("slickIndex");
		console.log('service dot', goToThisIndex);
		$('.service-slider').slick('slickGoTo', goToThisIndex, false);
	});

	// other work carousel
	$('.other-work-slider').slick({
		dots: true,
		arrows: false,
		infinite: false,
		speed: 300,
		slidesToShow: 4,
		slidesToScroll: 1,
		appendDots: '.other-work-dots'
	});

	// scrolling animations
	lax.setup() // init
	const updateLax = () => {
		lax.update(window.scrollY)
		window.requestAnimationFrame(updateLax)
	}
	window.requestAnimationFrame(updateLax)

	window.addEventListener("resize", function () {
		//console.log('lax update');
		lax.updateElements();
	});

	// scrolling add class
	$.fn.visible = function (partial) {

		var $t = $(this),
			$w = $(window),
			viewTop = $w.scrollTop(),
			viewBottom = viewTop + $w.height(),
			_top = $t.offset().top,
			_bottom = _top + $t.height(),
			compareTop = partial === true ? _bottom : _top,
			compareBottom = partial === true ? _top : _bottom;

		return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

	};

	// image seq scroll	
	if ($("[data-animated-block]").hasClass('img-seq-trigger')) {
		var scrollCount = 0,
			latestScrollTop = 0,
			doc = document.documentElement,
			top = 0,
			imgLimit = $('.img-seq').attr('data-sequence-limit'),
			dataSrc = $('.img-seq').attr('data-image-src');
	}

	$(window).scroll(function (event) {

		$("[data-animated-block]").each(function (i, el) {
			var el = $(el);
			if (el.visible(true)) {
				el.addClass("animateIn");
			} else {
				if (!el.hasClass('stat-block')) {
					el.removeClass("animateIn");
				}
			}

			// countup init		  
			if (el.hasClass('stat-block')) {
				$('.stat').each(function () {
					var $this = $(this),
						countTo = $this.attr('data-count');

					$({ countNum: $this.text() }).animate({
						countNum: countTo
					},
						{
							duration: 1000,
							easing: 'linear',
							step: function () {
								$this.text(Math.floor(this.countNum));
							},
							complete: function () {
								$this.text(this.countNum);
							}
						});
				});
			}
			if (el.hasClass('img-seq-trigger')) {
				if (el.visible(true)) {
					top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

					if (latestScrollTop < top) {
						if (scrollCount < 1) {
							scrollCount = 1;
						}
						if (scrollCount > imgLimit) {
							scrollCount = imgLimit;
						}
						if (scrollCount > 1 || scrollCount < imgLimit) {
							scrollCount += 1;
						}
					} else {
						if (scrollCount < 1) {
							scrollCount = 1;
						}
						if (scrollCount > imgLimit) {
							scrollCount = imgLimit;
						}
						if (scrollCount > 1 || scrollCount < imgLimit) {
							scrollCount -= 1;
						}
					}
					latestScrollTop = top;
					if (parseInt(scrollCount) === scrollCount) {
						$('.img-seq').attr("src", "" + dataSrc + scrollCount + ".png");
					}
					if (scrollCount < 1) {
						$('.img-seq').attr("src", "" + dataSrc + "/1.png");
					}
					if (scrollCount > imgLimit) {
						$('.img-seq').attr("src", "" + dataSrc + imgLimit + ".png");
					}
				}
			}
		});
	});

	// accordions
	const accordion = new Accordions();
	accordion.init();

	//console.log('loaded');

	// job list form reset
	const formResetButton = document.getElementById('formResetButton');
	const jobListForm = document.getElementById('jobListForm');
    if (formResetButton) {
        formResetButton.addEventListener('click', resetForm);
    }

	function resetForm() {
		document.querySelectorAll('input[type="text"]').forEach(input => {
			input.value = '';
		});		
		document.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
			checkbox.checked = false;
		});		
		const latitudeSelect = document.getElementById('latitude');
		if (latitudeSelect && latitudeSelect.value) {
			latitudeSelect.value = '';
		}
		const longitudeSelect = document.getElementById('longitude');
		if (longitudeSelect && longitudeSelect.value) {
			longitudeSelect.value = '';
		}
		const distanceSelect = document.getElementById('distance');
		if (distanceSelect) {
			distanceSelect.selectedIndex = 0;
		}		
		if (jobListForm) {
			console.log("jobListForm", jobListForm);		
			jobListForm.submit();
		}
	}

	/**
	 * Nav dropdown — mobile click / keyboard support
	 *
	 * Desktop:  hover handled entirely by CSS (no JS needed).
	 * Mobile:   clicking a .has-dropdown__trigger toggles .is-open
	 *           on its parent .has-dropdown li.
	 * Keyboard: Enter / Space on a trigger toggles the panel.
	 *           Escape closes any open panel.
	 *
	 * The breakpoint must match $nav-breakpoint in your SCSS.
	 */

	(function () {
	'use strict';

	var NAV_BREAKPOINT = 1024; // px — keep in sync with SCSS $nav-breakpoint
	var OPEN_CLASS     = 'is-open';
	var TRIGGER_SEL    = '.has-dropdown > .has-dropdown__trigger';
	var PARENT_SEL     = '.has-dropdown';

	// ── Helpers ────────────────────────────────────────────────────────────────

	function isMobile() {
		return window.innerWidth < NAV_BREAKPOINT;
	}

	function closeAll(except) {
		var open = document.querySelectorAll(PARENT_SEL + '.' + OPEN_CLASS);
		for (var i = 0; i < open.length; i++) {
		if (open[i] !== except) {
			open[i].classList.remove(OPEN_CLASS);
		}
		}
	}

	function toggleParent(parent) {
		var isOpen = parent.classList.contains(OPEN_CLASS);
		closeAll(parent);
		parent.classList.toggle(OPEN_CLASS, !isOpen);
	}

	// ── Click handler ──────────────────────────────────────────────────────────

	document.addEventListener('click', function (e) {
		if (!isMobile()) return;

		var trigger = e.target.closest(TRIGGER_SEL);

		if (trigger) {
		var parent = trigger.closest(PARENT_SEL);

		// If the trigger has a real href and it's NOT Sectors (no-link variant),
		// only open the dropdown — don't follow the link on first tap.
		// Second tap on an already-open item will fall through and navigate.
		if (
			trigger.getAttribute('href') &&
			trigger.getAttribute('href') !== '#' &&
			!parent.classList.contains(OPEN_CLASS)
		) {
			e.preventDefault();
		}

		if (parent.classList.contains('has-dropdown--no-link')) {
			e.preventDefault(); // never navigate for no-link items
		}

		toggleParent(parent);
		return;
		}

		// Click outside — close everything
		if (!e.target.closest(PARENT_SEL)) {
		closeAll();
		}
	});

	// ── Keyboard handler ───────────────────────────────────────────────────────

	document.addEventListener('keydown', function (e) {
		var key = e.key;

		// Escape: close all open panels
		if (key === 'Escape') {
		closeAll();
		return;
		}

		// Enter / Space on a trigger
		if (key === 'Enter' || key === ' ') {
		var trigger = e.target.closest(TRIGGER_SEL);
		if (!trigger) return;

		var parent = trigger.closest(PARENT_SEL);

		// Prevent page scroll on Space, prevent link follow on Enter for no-link
		if (key === ' ' || parent.classList.contains('has-dropdown--no-link')) {
			e.preventDefault();
		}

		toggleParent(parent);
		}
	});

	// ── Hover: ensure is-open is cleared when mouse enters on desktop ──────────
	// (Prevents a panel opened via keyboard/mobile staying "open" after resize)

	var parents = document.querySelectorAll(PARENT_SEL);
	for (var i = 0; i < parents.length; i++) {
		parents[i].addEventListener('mouseleave', function () {
		if (!isMobile()) {
			this.classList.remove(OPEN_CLASS);
		}
		});
	}

	}());	

});
